export default "__VITE_ASSET__SISXVfOHzvrvEjI0CfgJog__"